import { ConfigProvider } from "antd";
import { IntlProvider } from "react-intl";
import { Provider } from "react-redux";
import { ThemeProvider } from "styled-components";
import {
  getCurrentLanguage
} from "./containers/LanguageSwitcher/config";
import DashAppHolder from "./dashAppStyle";
import AppLocale from "./languageProvider";
import Boot from "./redux/boot";
import { history, store } from "./redux/store";
import PublicRoutes from "./router";
import { themeConfig } from "./settings";
import themes from "./settings/themes";


const DashApp = () => {
  const currentLang = getCurrentLanguage()
  const currentAppLocale = AppLocale[currentLang.locale]
  return (
    <ConfigProvider locale={currentAppLocale.antd}>
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <ThemeProvider theme={themes[themeConfig.theme]}>
          <DashAppHolder>
            <Provider store={store}>
              <PublicRoutes history={history} />
            </Provider>
          </DashAppHolder>
        </ThemeProvider>
      </IntlProvider>
    </ConfigProvider>
)};
Boot()
  .then(() => DashApp())
  .catch(error => console.error(error));

export default DashApp;
export { AppLocale };
